export enum TypedArray {
    Int16,
    Uint16,
    Int32,
    Uint32,
}
